import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const UpdateNoteRequestDtoSchema = z.object({
  id: z.number(),
  noteId: z.number(),
  noteText: z.string(),
});

const UpdateNoteResponseDtoSchema = z.object({
  id: z.number(),
  noteText: z.string(),
  takenBy: z.string(),
  creationDate: z.coerce.date(),
});

export type UpdateNoteRequestDto = z.infer<typeof UpdateNoteRequestDtoSchema>;
export type UpdateNoteResponseDto = z.infer<typeof UpdateNoteResponseDtoSchema>;

export const updateNote = (
  dto: UpdateNoteRequestDto,
  config?: AxiosRequestConfig<UpdateNoteRequestDto>
) => {
  const { id, noteId, ...data } = UpdateNoteRequestDtoSchema.parse(dto);

  return api
    .patch(`staff/${id}/notes/${noteId}`, data, config)
    .then(responseContract(UpdateNoteResponseDtoSchema));
};
